import React, { useEffect } from 'react';
import { useEstimationForm } from '../../../../contexts/EstimationFormContext';

interface StepContainerProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  onNext: () => void;
  onBack?: () => void;
  isValid?: boolean;
  nextLabel?: string;
}

export const StepContainer: React.FC<StepContainerProps> = ({
  title,
  description,
  children,
  onNext,
  onBack,
  isValid = true,
}) => {
  const ctx = useEstimationForm();

  useEffect(() => {
    if (!ctx) return;
    ctx.stepNavRef.current = { onNext, onBack };
  });

  useEffect(() => {
    ctx?.update({ stepIsValid: isValid });
  }, [isValid]); // eslint-disable-line

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [title]);

  return (
    <div className="space-y-6">
      <div>
        <h2 style={{ fontSize: 17, fontWeight: 600, color: '#1E1148', marginBottom: 4 }}>{title}</h2>
        {description && (
          <p style={{ fontSize: 13, color: '#7C6FA0' }}>{description}</p>
        )}
      </div>
      <div className="space-y-6">
        {children}
      </div>
    </div>
  );
};

export default StepContainer;
